import React, { useState } from 'react';
import { goToPreviousStep, goToNextStep } from '@src/stores/newFlowStore';
import { setReturnShipments, useReturnStore } from '@src/stores/returnStore';
import { useSummaryStore } from '@src/stores/summaryStore';
import {
  DATE_TIME_ADJUSTMENT,
  MORE_DATES_VALUE,
  REQUEST_DIFFERENT_DATE_VALUE,
} from '@src/utils/calendar';
import { ReturnButtons } from '../shared/ReturnButtons';
import { ReturnHeaders } from '../shared/ReturnHeaders';
import { LORPSchedulePickupStep } from './lorp-schedule-pickup/LORPSchedulePickupStep';

const LORPScheduleMethodFlow = () => {
  const [isScheduledPickupsLoading, setIsScheduledPickupsLoading] =
    useState(true);
  const selectedPickupDate = useSummaryStore(
    (state) => state.selectedPickupDate,
  );
  const returnShipments = useReturnStore((state) => state.returnShipments);
  const pickupShipments = returnShipments?.filter(
    (shipment) => shipment.shipmentType === 'PICKUP',
  );
  const sharedTextOptIn =
    pickupShipments?.some((shipment) => shipment.textOptIn === true) ?? false;
  const pickupDateToPersist =
    !selectedPickupDate ||
    selectedPickupDate === REQUEST_DIFFERENT_DATE_VALUE ||
    selectedPickupDate === MORE_DATES_VALUE
      ? ''
      : selectedPickupDate.replace(DATE_TIME_ADJUSTMENT, '');

  const handleBackButton = () => {
    goToPreviousStep();
  };

  const handleContinueButton = () => {
    if (returnShipments) {
      setReturnShipments(
        returnShipments.map((shipment) => {
          if (shipment.shipmentType === 'PICKUP') {
            return {
              ...shipment,
              textOptIn: sharedTextOptIn,
              pickupDate: pickupDateToPersist,
            };
          }
          return shipment;
        }),
      );
    }
    goToNextStep();
  };

  return (
    <div>
      <ReturnHeaders title="Choose your pickup date" />
      <>
        <LORPSchedulePickupStep
          onLoadingChange={setIsScheduledPickupsLoading}
        />
      </>
      {!isScheduledPickupsLoading && (
        <ReturnButtons
          proceedNext={handleContinueButton}
          proceedBack={handleBackButton}
        />
      )}
    </div>
  );
};

export default LORPScheduleMethodFlow;
